import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'

import './common/directives/select'
import './common/directives/datepicker'
import './common/directives/canaccess'
import './common/directives/htmleditor'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueMask from 'di-vue-mask'
Vue.use(VueMask)

import money from 'v-money'
Vue.use(money)

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue();

new Vue({
    router,
    render: h => h(App),
    mounted() {
        this.$eventHub.$on('show-notification', (data) => {

            let _config = {
                position: 'top',
                toast: IsMobile(),
                type: data.type,
                title: data.title,
                text: data.text,
                timer: 5000,
                showConfirmButton: false,
            }

            if (data.type == "error") {
                _config.timer = null;
                _config.showCancelButton = true;
                _config.cancelButtonText = "Fechar";
            }

            if (data.html) {
                _config.html = data.text;
                _config.text = "";
            }

            if (data.modal) {
                _config.position = 'center';
                _config.toast = false;
                _config.timer = null;
                if (data.type != "error")
                    _config.showConfirmButton = true;
            }

            function IsMobile() {
                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)
                ) {
                    return false;
                }
                else {
                    return true;
                }
            }

            this.$swal(_config);
        })
    },
    beforeDestroy() {
        this.$eventHub.$off('show-notification');
    },
}).$mount('#app')
